import {
    createBrowserRouter,
    RouterProvider
} from 'react-router-dom';


import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import 'mantine-datatable/styles.css';
import '@flexinet/ui-components/style.css'


import {MantineProvider} from "@mantine/core";
import {Notifications} from "@mantine/notifications";
import {AnalyticsAuthListener} from "@flexinet/analytics-components";
import {
    createAuthAwareQueryClient,
    SessionGuardProvider
} from "@flexinet/auth-components";
import {theme} from "./theme.ts";

import {AuthProvider} from "./providers/AuthProvider.tsx";
import {actions} from "./config/rbac/actions.ts";
import {VerifiedPermissionsProvider} from './providers/VerifiedPermissionsProvider.tsx';
import {routesConfig} from "./config/routes.tsx";
import {UserAttributesProvider} from './providers/UserAttributesProvider.tsx';
import {UserAccountProvider} from "./providers/UserAccountProvider.tsx";

import "vanilla-cookieconsent/dist/cookieconsent.css";
import {useCookieConsent} from "./features/accounts-management";
import {QueryClientProvider} from '@tanstack/react-query';

const router = createBrowserRouter(routesConfig)
const queryClient = createAuthAwareQueryClient()

export const App = () => {

    useCookieConsent();

    return (
        <MantineProvider theme={theme}>
            <Notifications position={'bottom-left'}/>
            <SessionGuardProvider>
                <QueryClientProvider client={queryClient}>
                    <AuthProvider>
                        <AnalyticsAuthListener/>
                        <UserAttributesProvider>
                            <UserAccountProvider>
                                <VerifiedPermissionsProvider actions={actions}>
                                    <RouterProvider router={router}/>
                                </VerifiedPermissionsProvider>
                            </UserAccountProvider>
                        </UserAttributesProvider>
                    </AuthProvider>
                </QueryClientProvider>
            </SessionGuardProvider>
        </MantineProvider>
    );
}

